import { Post } from '@/@types/post'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { CACHE_POSTS_QUERY_OPTIONS } from '../fetchers/post'

export default function usePost(id: string): Post | undefined {
	const { data: allPosts } = useQuery(CACHE_POSTS_QUERY_OPTIONS)
	return useMemo(() => allPosts?.[id], [id, allPosts])
}
